import {FileService} from '../../shared/services/file.service';
import {MimeTypeUtils} from '../../shared/mime-type-utils';
import {HttpResponse} from '@angular/common/http';

export class PodValidationDocument {
  public name: string;
  public content: Blob;
  public downloadUrl: string;

  static fromDto(dto: HttpResponse<Blob>): PodValidationDocument {
    if (dto.headers.has('Content-Disposition')) {
      const fileName = FileService.extractFileName(dto);
      const extension = fileName.split('.')[1];
      const content = new Blob(
        [dto.body],
        {type: MimeTypeUtils.getMimeTypeByExtension(extension)}
      )
      return new PodValidationDocument(fileName, content);
    } else {
      const downloadUrl = dto.headers.get('Location');
     return new PodValidationDocument(null, null, downloadUrl);
    }
  }

  constructor(name: string, content: Blob, downloadUrl = '') {
    this.name = name;
    this.content = content;
    this.downloadUrl = downloadUrl;
  }
}
